export const updateInterpolationGrid = (cell, weight) => ({
  type:'CHANGE_INTERPOLATION_GRID',
  gridCellSize: cell,
  distanceWeightingFactor: weight
})

export const changeClusterNumber = (value) => ({
  type:'CHANGE_NUMBER_OF_CLUSTERS',
  value
})

export const updateContours = (numbers, breaks) => ({
  type:'CHANGE_CONTOURS',
  nContours: numbers,
  contourBreaks: breaks
})

export const updateContourChoice = (choice) => ({
  type:'CHANGE_CONTOUR_CHOICE',
  choice: choice
})


// WEBPACK FOOTER //
// ./src/actions/uitool.js